import { subscriptionAccessLines } from "../../../utils/clubSubscriptionUi";
import ss from "./subscription.module.css";

export default function ClubSubscriptionAccessPanel({ access, billing }) {
  const lines = subscriptionAccessLines(access, billing);
  if (!lines.length) return null;

  return (
    <section className={ss.panel}>
      <h4 className={ss.panelTitle}>Что доступно сейчас</h4>
      <ul className={ss.accessList}>
        {lines.map((item) => (
          <li
            key={item.text}
            className={`${ss.accessItem} ${item.ok ? ss.accessItemOk : ""}`}
          >
            <span
              className={`${ss.accessMark} ${item.ok ? "" : ss.accessMarkOff}`}
              aria-hidden
            >
              {item.ok ? "✓" : "—"}
            </span>
            {item.text}
          </li>
        ))}
      </ul>
    </section>
  );
}
